import React, { FC } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

import Icon from '../../Media/Icon';

interface IProps {
  size?: '48';
  className?: string;
}

const Loader: FC<IProps> = ({ className, size }) => (
  <div className={classNames(css.loader, { [css[`loader_size_${size}`]]: size }, className)}>
    <Icon id={`colored--${size || '16'}--loader`} />
  </div>
);

export default Loader;
